import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { globalLang } from '~globalLang'

export enum CaptchaPurposes {
    signup = 'signup',
    login_confirm = 'login_confirm',
    confirm_2fa = 'confirm_2fa',
    change_password = 'change_password',
    pass_reset = 'pass_reset',
    disable_2fa = 'disable_2fa',
    add_permission = 'add_permission',
    delete_account = 'delete_account',
    add_auth_method = 'add_auth_method',
    confirm_2fa_yubikey = 'confirm_2fa_yubikey',
    disable_2fa_yubikey = 'disable_2fa_yubikey',
}

export enum CaptchaErrorCodes {
    captchaSkip = 'captchaSkip',
}

const SITE_KEY: string | undefined = import.meta.env.VITE_RECAPTCHA_SITE_KEY

export const useCaptcha = () => {
    const intl = useIntl()

    const executeCaptcha = useCallback(
        (action: CaptchaPurposes): Promise<string | undefined> => {
            if (!SITE_KEY || !window.grecaptcha?.enterprise) {
                return Promise.resolve(undefined)
            }

            return new Promise((resolve, reject) => {
                window.grecaptcha?.enterprise?.ready?.(async () => {
                    try {
                        const token = await window.grecaptcha?.enterprise?.execute?.(SITE_KEY, { action })
                        resolve(token)
                    } catch (error) {
                        reject(
                            new Error(intl.formatMessage(globalLang.captchaSkipError), {
                                cause: { error, code: CaptchaErrorCodes.captchaSkip },
                            })
                        )
                    }
                })
            })
        },
        [intl]
    )

    return { executeCaptcha }
}
